export const VALUES_CONTENT = [
  {
    valueName: "Sustainability",
    valueDesc:
      "Our mission is focused on creating open sustainability within social networking and build OSS/FOSS social-environmental tools with a sole motive to benefit organizations and individuals.",
    valueLink:
      "https://docs.codeuino.org/documentation/our-values#sustainability",
  },
  {
    valueName: "Collaboration",
    valueDesc:
      "Collaboration is important to sustain a successful organization. Helping others is our priority, even when it is not immediately related to the goals that we are trying to achieve. ",
    valueLink:
      "https://docs.codeuino.org/documentation/our-values#collaboration",
  },
  {
    valueName: "Openness",
    valueDesc:
      "Openness is the key to any open source project. Work within the Codeuino community is primarily organized around open social networking. We strive to be open!",
    valueLink: "https://docs.codeuino.org/documentation/our-values#openness",
  },
  {
    valueName: "Transparency",
    valueDesc:
      "Transparency creates awareness for Codeuino community, allows us to recruit people that care about our values, gets us more and faster feedback, and makes it easier to collaborate with them.",
    valueLink:
      "https://docs.codeuino.org/documentation/our-values#transparency",
  },
  {
    valueName: "Efficiency",
    valueDesc:
      "We care about working on the right things, not doing more than needed, and not duplicating work. This enables us to achieve more progress, which makes our work more fulfilling.",
    valueLink: "https://docs.codeuino.org/documentation/our-values#efficiency",
  },
  {
    valueName: "Diversity",
    valueDesc:
      "Diversity, inclusion, and belonging are fundamental to the success of the Codeuino  community. We actively chose to build and institutionalize a culture that is inclusive.",
    valueLink: "https://docs.codeuino.org/documentation/our-values#diversity",
  },
  {
    valueName: "Consistency",
    valueDesc:
      "Being consistent with our day job helps us to stay motivated and encouraged. We are dependable, reliable, and responsible for our decisions and actions every single day.",
    valueLink: "https://docs.codeuino.org/documentation/our-values#consistency",
  },
];
